var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAlarmAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84412,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#12B76A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84412,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#039855",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5002 29.1774V33.8441M33.5002 38.5108H33.5118M45.1668 33.8441C45.1668 40.2874 39.9435 45.5108 33.5002 45.5108C27.0568 45.5108 21.8335 40.2874 21.8335 33.8441C21.8335 27.4008 27.0568 22.1774 33.5002 22.1774C39.9435 22.1774 45.1668 27.4008 45.1668 33.8441Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAlarmAlert);
export default __webpack_public_path__ + "static/media/clear-alarm-alert.d2d3c34ad654585bd77e8f80a2fed7a1.svg";
export { ForwardRef as ReactComponent };